import { rrulestr } from "rrule";
import moment from "moment";

const { datesForRule } = require("../../helpers/repeatingEventDateRange.js");

const state = {
  repeatingEventDateCache: {},
};

const getters = {
  repeatingEventDateCache(state) {
    return state.repeatingEventDateCache;
  },
};

const mutations = {
  resetRepeatingEventDateCache(state) {
    state.repeatingEventDateCache = {};
  },
  loadRepeatingEventDateCache(state, repeatingEventList) {
    for (const [id, re] of Object.entries(repeatingEventList)) {
      if (!re || !re.repeating_rule) continue;
      const rule = rrulestr(re.repeating_rule);
      datesForRule(rule).forEach((date) => {
        const key = moment.utc(date).format("YYYYMMDD");
        const bucket = state.repeatingEventDateCache[key];
        if (bucket) {
          if (!bucket.includes(id)) bucket.push(id);
        } else {
          state.repeatingEventDateCache[key] = [id];
        }
      });
    }
  },
  addRepeatingEventToDateCache(state, re) {
    if (!re || !re.repeating_rule || !re.id) return;
    const rule = rrulestr(re.repeating_rule);
    datesForRule(rule).forEach((date) => {
      const key = moment.utc(date).format("YYYYMMDD");
      const bucket = state.repeatingEventDateCache[key];
      if (bucket) {
        if (!bucket.includes(re.id)) bucket.push(re.id);
      } else {
        state.repeatingEventDateCache[key] = [re.id];
      }
    });
  },
};

export default {
  namespaced: false,
  state,
  getters,
  mutations,
};
